import { z } from "zod";

export const sessionDaySchema = z.object({
  id: z.number().optional(),
  startDate: z.string(),
  endDate: z.string(),
});

export const sessionAttachmentSchema = z.object({
  fileUuid: z.string(),
  fileName: z.string(),
  contentType: z.string().nullable().optional(),
  fileSize: z.number().nullable().optional(),
});

export const eventSessionFormSchema = z.object({
  name: z.string().min(1, "Session name is required"),
  startDate: z.string().min(1, "Start date is required"),
  endDate: z.string().min(1, "End date is required"),
  sessionDays: z.array(sessionDaySchema).optional(),
  maxEnrollments: z.coerce
    .number()
    .min(0, "Max enrollments must be ≥ 0")
    .optional(),
  virtualLink: z.string().optional(),
  notes: z.string().optional(),
  isPublished: z.boolean().optional(),
  instructorId: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable(),
  isVirtualOnly: z.boolean().optional(),
  redirectToLegacy: z.boolean().optional(),
  venueId: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable(),
  timezoneId: z
    .number({
      required_error: "Timezone is required",
      invalid_type_error: "Timezone must be a number",
    })
    .min(1, "Please select a valid timezone"),
  attachments: z.array(sessionAttachmentSchema).optional(),
});

export type EventSessionFormValues = z.infer<typeof eventSessionFormSchema>;
